<template>
    <div>
        <el-card>
            <div slot="header" class="clearfix">
                <el-row type="flex" align="middle">
                    <el-col class="card-heading">Test Web Sockets</el-col>
                    <el-col>
                        <el-button
                            class="test-button"
                            @click="runTest"
                            :loading="testing"
                            >Test</el-button
                        >
                    </el-col>
                </el-row>
            </div>
            <el-row>
                <el-col :span="20" class="result-heading">
                    websockets Enabled:
                </el-col>
                <el-col :span="4">
                    <i
                        class="el-icon-success"
                        v-if="webSocketEnabled === true"
                    ></i>
                    <i
                        class="el-icon-error"
                        v-else-if="webSocketEnabled === false"
                    ></i>
                    <i class="el-icon-warning" v-else></i>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20" class="result-heading">
                    Connection Status:
                </el-col>
                <el-col :span="4">
                <i class="el-icon-success" v-if="connectionStatus === true"></i>
                <i
                    class="el-icon-error"
                    v-else-if="connectionStatus === false"
                ></i>
                <i class="el-icon-warning" v-else></i>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>

<script>
import io from 'socket.io-client';
export default {
    data() {
        return {
            webSocketEnabled: null,
            connectionStatus: null,
            testing: false,
        };
    },
    watch:{
        connectionStatus(){
            this.emitError();
        },
        webSocketEnabled(){
            this.emitError();
        }
    },
    methods: {
        runTest() {
            this.testing = true;
            this.checkWebSockets();
            const SECOND = 1000; // milliseconds
            const socket = io(`${process.env.VUE_APP_SERVER_URL}ping`, {
                reconnection: true,
                reconnectionAttempts: 3,
                reconnectionDelay: 1 * SECOND,
                reconnectionDelayMax: 1 * SECOND,
            });
            socket.on('connect', () => {
                socket.on('CONNECTED', () => {
                    this.handleSuccess();
                });
            });
            socket.on('reconnect_error', () => {
                this.handleError();
            });
            socket.on('reconnect_failed', () => {
                this.handleError();
            });
        },
        handleError() {
            this.connectionStatus = false;
            this.testing = false;
        },
        handleSuccess() {
            this.connectionStatus = true;
            this.testing = false;
        },
        checkWebSockets() {
            this.webSocketEnabled = !!window.WebSocket;
        },
        emitError(){
            let error = !(this.webSocketEnabled && this.connectionStatus);
            this.$emit('changeError',error);
        }
    },
};
</script>
<style scoped>
.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: '';
}
.clearfix:after {
    clear: both;
}

.test-button {
    float: right;
}
i {
    font-size: 30px;
}
i.el-icon-success {
    color: #43a047;
}
i.el-icon-error {
    color: #d32f2f;
}
div.result-heading,
div.card-heading {
    text-align: left;
}
</style>
